module.exports = __webpack_public_path__ + "3caf7aea879263e4d2075cf07a10db5c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/caret.svg
// module id = 81
// module chunks = 0